/**
 * Single source of truth for the questionnaire-answer attachment limits.
 *
 * The maximum size is kept in sync with the backend
 * (`S3PresignedUrlRequest::MAX_ATTACHMENT_SIZE_BYTES`), which rejects oversized
 * uploads with a structured 4xx response before handing out a pre-signed URL.
 */
export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

export const SUPPORTED_FORMATS = ["pdf", "docx", "pptx", "xlsx", "png", "jpeg", "jpg"];

/** File extension, lower-cased for comparison against {@link SUPPORTED_FORMATS}. */
export const getFileExtension = (filename: string): string => filename.split(".").pop() ?? "";

export const isSupportedFormat = (filename: string): boolean => SUPPORTED_FORMATS.includes(getFileExtension(filename));

export const isFileTooLarge = (size: number): boolean => size > MAX_FILE_SIZE;

/** Human-readable size in MB (one decimal), used in the "file too large" error message. */
export const formatFileSizeMb = (bytes: number): string => (bytes / (1024 * 1024)).toFixed(1);
